// CategorySlider.jsx
import React, { useRef, useEffect } from "react";
import CategoryCard from "./CategoryCard";

const CategorySlider = ({ categories, selected, onSelect }) => {
    const scrollRef = useRef(null);
    const cardRefs = useRef({});

    useEffect(() => {
        const el = scrollRef.current;
        const key = selected?.title?.toLowerCase();
        const selectedCard = cardRefs.current[key];

        if (el && selectedCard) {
            requestAnimationFrame(() => {
                const elRect = el.getBoundingClientRect();
                const cardRect = selectedCard.getBoundingClientRect();
                const scrollLeft = el.scrollLeft;

                const offset = cardRect.left - elRect.left - elRect.width / 2 + cardRect.width / 2;

                let newScrollLeft = scrollLeft + offset;
                newScrollLeft = Math.max(0, Math.min(newScrollLeft, el.scrollWidth - el.clientWidth));

                el.scrollTo({ left: newScrollLeft, behavior: "smooth" });
            });
        }
    }, [selected]);

    return (
        <div
            ref={scrollRef}
            className="overflow-x-auto no-scrollbar scroll-smooth px-4 py-2"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
            <div className="flex gap-2 w-max">
                {categories.map((cat) => (
                    <div
                        key={cat.title}
                        ref={(el) => (cardRefs.current[cat.title.toLowerCase()] = el)}
                    >
                        <CategoryCard
                            label={cat.title}
                            selected={selected?.toLowerCase() === cat.title.toLowerCase()}
                            onClick={() => onSelect(cat)}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CategorySlider;